const actions = {
  CATEGORY_DATA_BEGIN: "CATEGORY_DATA_BEGIN",
  CATEGORY_DATA_SUCCESS: "CATEGORY_DATA_SUCCESS",
  CATEGORY_DATA_ERR: "CATEGORY_DATA_ERR",

  BRAND_DATA_BEGIN: "BRAND_DATA_BEGIN",
  BRAND_DATA_SUCCESS: "BRAND_DATA_SUCCESS",
  BRAND_DATA_ERR: "BRAND_DATA_ERR",

  STORE_LIST_DATA_BEGIN: "STORE_LIST_DATA_BEGIN",
  STORE_LIST_DATA_SUCCESS: "STORE_LIST_DATA_SUCCESS",
  STORE_LIST_DATA_ERR: "STORE_LIST_DATA_ERR",

  STORE_PINCODE_DATA_BEGIN: "STORE_PINCODE_DATA_BEGIN",
  STORE_PINCODE_DATA_SUCCESS: "STORE_PINCODE_DATA_SUCCESS",
  STORE_PINCODE_DATA_ERR: "STORE_PINCODE_DATA_ERR",
  STORE_PINCODE_DATA_RESET: "STORE_PINCODE_DATA_RESET",

  MODEL_LIST_DATA_BEGIN: "MODEL_LIST_DATA_BEGIN",
  MODEL_LIST_DATA_SUCCESS: "MODEL_LIST_DATA_SUCCESS",
  MODEL_LIST_DATA_ERR: "MODEL_LIST_DATA_ERR",

  STOCK_EMPLOYEE_LIST_DATA_BEGIN: "STOCK_EMPLOYEE_LIST_DATA_BEGIN",
  STOCK_EMPLOYEE_LIST_DATA_SUCCESS: "STOCK_EMPLOYEE_LIST_DATA_SUCCESS",
  STOCK_EMPLOYEE_LIST_DATA_ERR: "STOCK_EMPLOYEE_LIST_DATA_ERR",

  MAINTENANCE_EMPLOYEE_LIST_DATA_BEGIN: "MAINTENANCE_EMPLOYEE_LIST_DATA_BEGIN",
  MAINTENANCE_EMPLOYEE_LIST_DATA_SUCCESS:
    "MAINTENANCE_EMPLOYEE_LIST_DATA_SUCCESS",
  MAINTENANCE_EMPLOYEE_LIST_DATA_ERR: "MAINTENANCE_EMPLOYEE_LIST_DATA_ERR",

  VENDOR_EMPLOYEE_LIST_DATA_BEGIN: "VENDOR_EMPLOYEE_LIST_DATA_BEGIN",
  VENDOR_EMPLOYEE_LIST_DATA_SUCCESS: "VENDOR_EMPLOYEE_LIST_DATA_SUCCESS",
  VENDOR_EMPLOYEE_LIST_DATA_ERR: "VENDOR_EMPLOYEE_LIST_DATA_ERR",

  STATE_LIST_DATA_BEGIN: "STATE_LIST_DATA_BEGIN",
  STATE_LIST_DATA_SUCCESS: "STATE_LIST_DATA_SUCCESS",
  STATE_LIST_DATA_ERR: "STATE_LIST_DATA_ERR",

  LANGUAGE_LIST_DATA_BEGIN: "LANGUAGE_LIST_DATA_BEGIN",
  LANGUAGE_LIST_DATA_SUCCESS: "LANGUAGE_LIST_DATA_SUCCESS",
  LANGUAGE_LIST_DATA_ERR: "LANGUAGE_LIST_DATA_ERR",

  PRODUCT_TYPE_BEGIN: "PRODUCT_TYPE_BEGIN",
  PRODUCT_TYPE_SUCCESS: "PRODUCT_TYPE_SUCCESS",
  PRODUCT_TYPE_ERR: "PRODUCT_TYPE_ERR",

  BRAND_BEGIN: "BRAND_BEGIN",
  BRAND_SUCCESS: "BRAND_SUCCESS",
  BRAND_ERR: "BRAND_ERR",

  MODEL_BEGIN: "MODEL_BEGIN",
  MODEL_SUCCESS: "MODEL_SUCCESS",
  MODEL_ERR: "MODEL_ERR",

  EMPLOYEE_DETAIL_BEGIN: "EMPLOYEE_DETAIL_BEGIN",
  EMPLOYEE_DETAIL_SUCCESS: "EMPLOYEE_DETAIL_SUCCESS",
  EMPLOYEE_DETAIL_ERR: "EMPLOYEE_DETAIL_ERR",
  EMPLOYEE_DETAIL_RESET: "EMPLOYEE_DETAIL_RESET",

  EXCHANGE_MODEL_BEGIN: "EXCHANGE_MODEL_BEGIN",
  EXCHANGE_MODEL_SUCCESS: "EXCHANGE_MODEL_SUCCESS",
  EXCHANGE_MODEL_ERR: "EXCHANGE_MODEL_ERR",

  APEX_TRADE_MODEL_LIST_BEGIN: "APEX_TRADE_MODEL_LIST_BEGIN",
  APEX_TRADE_MODEL_LIST_SUCCESS: "APEX_TRADE_MODEL_LIST_SUCCESS",
  APEX_TRADE_MODEL_LIST_ERR: "APEX_TRADE_MODEL_LIST_ERR",

  TRADE_MODEL_LIST_BEGIN: "TRADE_MODEL_LIST_BEGIN",
  TRADE_MODEL_LIST_SUCCESS: "TRADE_MODEL_LIST_SUCCESS",
  TRADE_MODEL_LIST_ERR: "TRADE_MODEL_LIST_ERR",


  categoryDataBegin: () => {
    return {
      type: actions.CATEGORY_DATA_BEGIN,
    };
  },

  categoryDataSuccess: (data) => {
    return {
      type: actions.CATEGORY_DATA_SUCCESS,
      data,
    };
  },

  categoryDataErr: (err) => {
    return {
      type: actions.CATEGORY_DATA_ERR,
      err,
    };
  },

  brandDataBegin: () => {
    return {
      type: actions.BRAND_DATA_BEGIN,
    };
  },

  brandDataSuccess: (data) => {
    return {
      type: actions.BRAND_DATA_SUCCESS,
      data,
    };
  },

  brandDataErr: (err) => {
    return {
      type: actions.BRAND_DATA_ERR,
      err,
    };
  },

  storeListDataBegin: () => {
    return {
      type: actions.STORE_LIST_DATA_BEGIN,
    };
  },

  storeListDataSuccess: (data) => {
    return {
      type: actions.STORE_LIST_DATA_SUCCESS,
      data,
    };
  },

  storeListDataErr: (err) => {
    return {
      type: actions.STORE_LIST_DATA_ERR,
      err,
    };
  },

  storePincodeDataBegin: () => {
    return {
      type: actions.STORE_PINCODE_DATA_BEGIN,
    };
  },

  storePincodeDataSuccess: (data) => {
    return {
      type: actions.STORE_PINCODE_DATA_SUCCESS,
      data,
    };
  },

  storePincodeDataErr: (err) => {
    return {
      type: actions.STORE_PINCODE_DATA_ERR,
      err,
    };
  },

  storePincodeDataReset: () => {
    return {
      type: actions.STORE_PINCODE_DATA_RESET,
    };
  },

  modelListDataBegin: () => {
    return {
      type: actions.MODEL_LIST_DATA_BEGIN,
    };
  },

  modelListDataSuccess: (data) => {
    return {
      type: actions.MODEL_LIST_DATA_SUCCESS,
      data,
    };
  },

  modelListDataErr: (err) => {
    return {
      type: actions.MODEL_LIST_DATA_ERR,
      err,
    };
  },

  stockEmployeeListDateBegin: () => {
    return {
      type: actions.STOCK_EMPLOYEE_LIST_DATA_BEGIN,
    };
  },

  stockEmployeeListDataSuccess: (data) => {
    return {
      type: actions.STOCK_EMPLOYEE_LIST_DATA_SUCCESS,
      data,
    };
  },

  stockEmployeeListDataErr: (err) => {
    return {
      type: actions.STOCK_EMPLOYEE_LIST_DATA_ERR,
      err,
    };
  },

  maintenanceEmployeeListDateBegin: () => {
    return {
      type: actions.MAINTENANCE_EMPLOYEE_LIST_DATA_BEGIN,
    };
  },

  maintenanceEmployeeListDateSuccess: (data) => {
    return {
      type: actions.MAINTENANCE_EMPLOYEE_LIST_DATA_SUCCESS,
      data,
    };
  },

  maintenanceEmployeeListDateErr: (err) => {
    return {
      type: actions.MAINTENANCE_EMPLOYEE_LIST_DATA_ERR,
      err,
    };
  },

  vendorEmployeeListDataBegin: () => {
    return {
      type: actions.VENDOR_EMPLOYEE_LIST_DATA_BEGIN,
    };
  },

  vendorEmployeeListDataSuccess: (data) => {
    return {
      type: actions.VENDOR_EMPLOYEE_LIST_DATA_SUCCESS,
      data,
    };
  },

  vendorEmployeeListDataErr: (err) => {
    return {
      type: actions.VENDOR_EMPLOYEE_LIST_DATA_ERR,
      err,
    };
  },

  stateListDataBegin: () => {
    return {
      type: actions.STATE_LIST_DATA_BEGIN,
    };
  },

  stateListDataSuccess: (data) => {
    return {
      type: actions.STATE_LIST_DATA_SUCCESS,
      data,
    };
  },

  stateListDataErr: (err) => {
    return {
      type: actions.STATE_LIST_DATA_ERR,
      err,
    };
  },

  languageListDataBegin: () => {
    return {
      type: actions.LANGUAGE_LIST_DATA_BEGIN,
    };
  },

  languageListDataSuccess: (data) => {
    return {
      type: actions.LANGUAGE_LIST_DATA_SUCCESS,
      data,
    };
  },

  languageListDataErr: (err) => {
    return {
      type: actions.LANGUAGE_LIST_DATA_ERR,
      err,
    };
  },
  getProductTypeBegin: () => {
    return {
      type: actions.PRODUCT_TYPE_BEGIN,
    };
  },
  getProductTypeSuccess: (data) => {
    return {
      type: actions.PRODUCT_TYPE_SUCCESS,
      data,
    };
  },
  getProductTypeErr: (err) => {
    return {
      type: actions.PRODUCT_TYPE_ERR,
      err,
    };
  },
  getModelBegin: () => {
    return {
      type: actions.MODEL_BEGIN,
    };
  },
  getModelSuccess: (data) => {
    return {
      type: actions.MODEL_SUCCESS,
      data,
    };
  },
  getModelErr: (err) => {
    return {
      type: actions.MODEL_ERR,
      err,
    };
  },

  getBrandBegin: () => {
    return {
      type: actions.BRAND_BEGIN,
    };
  },
  getBrandSuccess: (data) => {
    return {
      type: actions.BRAND_SUCCESS,
      data,
    };
  },
  getBrandErr: (err) => {
    return {
      type: actions.BRAND_ERR,
      err,
    };
  },
  getEmployeeDetailBegin: () => {
    return {
      type: actions.EMPLOYEE_DETAIL_BEGIN,
    };
  },
  getEmployeeDetailSuccess: (data) => {
    return {
      type: actions.EMPLOYEE_DETAIL_SUCCESS,
      data,
    };
  },
  getEmployeeDetailErr: (err) => {
    return {
      type: actions.EMPLOYEE_DETAIL_ERR,
      err,
    };
  },
  getEmployeeDetailDataReset: () => {
    return {
      type: actions.EMPLOYEE_DETAIL_RESET,
    };
  },
  getExchangeModelBegin: () => {
    return {
      type: actions.EXCHANGE_MODEL_BEGIN,
    };
  },
  getExchangeModelSuccess: (data) => {
    return {
      type: actions.EXCHANGE_MODEL_SUCCESS,
      data,
    };
  },
  getExchangeModelErr: (err) => {
    return {
      type: actions.EXCHANGE_MODEL_ERR,
      err,
    };
  },

  getApexTradeModelListBegin: () => {
    return {
      type: actions.APEX_TRADE_MODEL_LIST_BEGIN,
    };
  },
  getApexTradeModelListSuccess: (data) => {
    return {
      type: actions.APEX_TRADE_MODEL_LIST_SUCCESS,
      data,
    };
  },
  getApexTradeModelListErr: (err) => {
    return {
      type: actions.APEX_TRADE_MODEL_LIST_ERR,
      err,
    };
  },

  getTradeModelListBegin: () => {
    return {
      type: actions.TRADE_MODEL_LIST_BEGIN,
    };
  },
  getTradeModelListSuccess: (data) => {
    return {
      type: actions.TRADE_MODEL_LIST_SUCCESS,
      data,
    };
  },
  getTradeModelListErr: (err) => {
    return {
      type: actions.TRADE_MODEL_LIST_ERR,
      err,
    };
  },
};

export default actions;
